import React, {useEffect, useState} from 'react';
import MediaLibraryManager from '../../Media/MediaLibraryManager';

export default function MastheadImage({image, imageId, isBlog = false, onChange}) {
    const [selectedImage, setSelectedImage] = useState(image || null);
    const [pickerOpen, setPickerOpen] = useState(false);

    useEffect(() => {
        if (!imageId) setSelectedImage(null);
        else if (image?.id === imageId) setSelectedImage(image);
    }, [image, imageId]);

    return <section className="content-editor-panel" aria-labelledby="masthead-image-title">
        <h2 id="masthead-image-title">Masthead image</h2>
        <p>
            Used across the top of masthead layouts. Choose it from the same media library as the
            gallery, without adding it to the gallery itself.
        </p>
        {selectedImage
            ? <img className="content-masthead-preview" src={selectedImage.cdnUrl}
                alt={selectedImage.metadata?.altText || selectedImage.description || ''} />
            : <p className="help">{isBlog
                ? 'No separate masthead selected. The featured image will be used.'
                : 'No masthead image selected.'}</p>}
        <div className="content-media-actions">
            <button type="button" className="button small"
                onClick={() => setPickerOpen(true)}>Choose image</button>
            {selectedImage && <button type="button" className="button small secondary"
                onClick={() => {
                    setSelectedImage(null);
                    onChange?.(null);
                }}>Remove</button>}
        </div>
        {pickerOpen && <MediaLibraryManager
            variant="modal"
            isOpen
            selectable
            accept="image/*"
            title="Choose masthead image"
            onSelect={selected => {
                setSelectedImage(selected);
                onChange?.(selected.id);
                setPickerOpen(false);
            }}
            onCancel={() => setPickerOpen(false)}
        />}
    </section>;
}
